"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: ["goals"],

  data: function data() {
    return {
      posting: false,
      goal: null,
      loaded: false,
      errors: [],
      oldInput: []
    };
  },
  mounted: function mounted() {
    this.setGoal(parseInt(this.$parent.params));
    var requestData = this.$store.getters.pullRequestErrorsAndOldInputByAction("edit-health-goal");
    this.errors = requestData.errors;
    this.oldInput = requestData.oldInput;

    if (!_.isEmpty(this.oldInput)) {
      this.goal.text = this.oldInput.text;
    }

    this.loaded = true;
  },


  computed: {
    url: function url() {
      return "/goal/" + this.goal.id;
    }
  },

  methods: {
    setGoal: function setGoal(id) {
      id = parseInt(id);
      this.goal = _(this.goals).find({ id: id });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/menu/EditHealthGoalMenu.vue
// module id = kLKF
// module chunks = 0 1